/*
if(self.oldProto == undefined){
	self.oldProto = WeakMap.prototype.set;
}
(function () {
	var send_hook = WeakMap.prototype.set;
	WeakMap.prototype.set = function () {
		if(self.RMI == undefined && arguments.length > 1 && arguments[1] != undefined && arguments[1] != null  && arguments[1].currentRMI){
			self.RMI = arguments[1].currentRMI;
			WeakMap.prototype.set = self.oldProto;
		}
		return send_hook.apply(this, arguments);
	};
})();
*/
import wixWindow from 'wix-window';
import wixData from 'wix-data';
import wixLocation from 'wix-location';
import {getMobileBrowseByItemsList , getBrowseByItemsList} from 'backend/backend.jsw';
var browse_by_items = null;
var mobileListOpen = false;
var openListType = "";

$w.onReady(function () {
	$w("#text43").text == "";
	
	if(wixWindow.formFactor == "Desktop"){
		if($w("#disciplineDropdown").options === undefined  || $w("#disciplineDropdown").options.length == 0){
			getBrowseByItemsList().then(items => {
				$w("#disciplineDropdown").options = items.discipline;
				$w("#yearDropdown").options = items.year;
				$w("#lastnameDropdown").options = items.lastName;
			})
			.catch(error => {
				console.log(error);
			});
		}
	}else{
		if(browse_by_items == null){
			closeMobileList();
			getMobileBrowseByItemsList().then(items => {
				browse_by_items = items;
			})
			.catch(error => {
				console.log(error);
			});
		}
	}
	if(wixWindow.formFactor == "Desktop"){
	//	$w("#text14").html = '<p style="background-image:url(https://images-wixmp-8cbe8e680e95a22c77c8d3d0.wixmp.com/media_manager_demo/users/118230388882954735362-ggl/8b836661adeb4fe2a39c66778ee1fccb.svg);position:fixed;left:0px;top:0px;width:100vw;height:150px;background-size: cover;background-repeat:repeat-x;z-index:-2;background-position: left top;" ></p>';
	//	$w("Document").background.src = 'https://images-wixmp-8cbe8e680e95a22c77c8d3d0.wixmp.com/media_manager_demo/users/118230388882954735362-ggl/8b836661adeb4fe2a39c66778ee1fccb.svg';
		//$w("#text5").html = $w("#text5").html.replace("<h6",'<h6 style="width: calc(100vw - 140px); margin-left:70px;" ');
		//self.RMI.setLayout($w("#text5").uniqueId, {fixedPosition:false,docked:{left:{vw:0,px:70},right:{vw:0,px:70}}});
		//self.RMI.setLayout($w("#text98").uniqueId, {fixedPosition:false,docked:{left:{vw:0,px:70},right:{vw:0,px:70}}});
		//$w("#text98").html = $w("#text98").html.replace("<h6",'<h6 style="position:absolute;left: calc((100vw - 980px)/-2); margin-left:70px;" ');
	}else{
		//$w("Document").background.src = 'https://images-wixmp-8cbe8e680e95a22c77c8d3d0.wixmp.com/media_manager_demo/users/118230388882954735362-ggl/ebca1758d1504663a034819ccf56296d.svg';
		$w("#browsebyList").html ='';
		$w("#browsebyList").hide();
		$w("#mobileSearchBox").show();
		$w("#searchButtonMobile").show();
		$w("#browsebyBox").expand();
		$w("#browsebyBox").show();
		$w("#searchButtonMobile").src = 'https://images-wixmp-8cbe8e680e95a22c77c8d3d0.wixmp.com/media_manager_demo/users/118230388882954735362-ggl/f7e2a3db7f3a4351bba7f3458bba4f4d.svg';
		$w("#text14").html ='<h2 style="font-family:wfont_171703_fa1d0d51018d425583c9fbe2d2e254db,wf_fa1d0d51018d425583c9fbe2d,orig_nhaasgroteskdsw_02_blk;color:#fff;font-size:30px;line-height: 0.9;text-align:left;display:inline-block;"><a target="_self" href="' + wixLocation.baseUrl + '" ><span style="font-size:30px;" >Design<br>Matters</span><br><span style="font-size:13px;"><span style="font-size:13px;">with&nbsp;</span>Debbie Millman</span></a></h2>';
		//self.RMI.setLayout($w("#box3").uniqueId, {fixedPosition:true,docked:{bottom:{"px":0},right:{"px":9},left:{"px":9}}});
	}
});
export function go_click(event, $w) {
	if($w("#searchInput").value.trim().length > 2){
		 wixLocation.to("https://debbiemillman.wixsite.com/debbiemillman/search?term=" +  $w("#searchInput").value.trim());
	}
}

export function searchInput_change(event, $w) {
	//search();
}

export function searchInput_keyPress(event, $w) {
	console.log( $w("#searchInput").value);
	if(event.key == "Enter" &&  $w("#searchInput").value.trim().length > 2){
		 wixLocation.to(wixLocation.baseUrl + "/search?term=" +  $w("#searchInput").value.trim());
	}
}
export function clearSearch_click(event, $w) {
	if($w("#searchInput").value.length > 0){
		$w("#searchInput").value = "";
	}
}
export function input1_focus(event, $w) {
	$w("#browsebyBox").expand();
	$w("#browsebyBox").show();
}
function closeMobileList(){
	$w("#browsebyList").hide();
	$w("#browsebyList").html = '';
	mobileListOpen = false;
	$w("#box3").hide();
	openListType = "";
}
// discipline
export function disciplineList_mobile_click(event, $w) {
	if(mobileListOpen && openListType == "disciplineList" ){
		closeMobileList();
		return;
	}
	$w("#browsebyList").html = browse_by_items.discipline;
	$w("#browsebyList").show();
	mobileListOpen = true;
	openListType = "disciplineList";
}
// year
export function year_mobile_click(event, $w) {
	if(mobileListOpen && openListType == "yearList" ){
		closeMobileList();
		return;
	}
	$w("#browsebyList").html = browse_by_items.year;
	$w("#browsebyList").show();
	mobileListOpen = true;
	openListType = "yearList";
}
// lastName
export function lastname_mobile_clcick(event, $w) {
	if(mobileListOpen && openListType == "lastNameList" ){
		closeMobileList();
		return;
	}
	$w("#browsebyList").html = browse_by_items.lastName;
	$w("#browsebyList").show();
	mobileListOpen = true;
	openListType = "lastNameList";
}
export function browsebyList_viewportEnter(event, $w) {
	if(mobileListOpen){
		$w("#box3").show();
	}
}
export function browsebyList_viewportLeave(event, $w) {
	if(mobileListOpen){
		$w("#box3").hide();
	}
}
export function box3_click(event, $w) {
	closeMobileList();
}

export function input1_keyPress(event, $w) {
	if(event.key == "Enter" &&  $w("#searchInputMobile").value.trim().length > 2){
		wixLocation.to(wixLocation.baseUrl + "/search?term=" +  $w("#searchInputMobile").value.trim());
	}
}

export function disciplineDropdown_change(event, $w) {
	wixLocation.to(event.target.value);
}

export function yearDropdown_change(event, $w) {
	wixLocation.to(event.target.value);
}

export function lastnameDropdown_change(event, $w) {
	wixLocation.to(event.target.value);
}